import React from 'react'
import PropTypes from 'prop-types'
import Header from './header'
import Footer from 'src/components/core/uxdx/footer'
import Announcement from '../announcement'
import LoginModal from 'src/components/modals/login-modal'
import { graphql, useStaticQuery, Link } from 'gatsby'
import { useAuthService } from 'theme/services/auth/auth-service'
// import CookieConsent from 'react-cookie-consent'
import { AppServiceProvider } from 'theme/services/app-service'

const BasicLayout = ({ children, conference, conferenceLinks, inPerson }) => {
  const authService = useAuthService()
  // const { confAnnouncements } = useStaticQuery(query)

  if (!conferenceLinks) conferenceLinks = { tickets: false, speakers: false }

  // const filteredAnnouncements = confAnnouncements.nodes.filter(
  //   (ann) => ann.data.Conference.id === conference.id,
  // )
  const filteredAnnouncements = []

  return (
    // FIXME: we don't load pageProps atm as uxdx is now the default config for all components
    <AppServiceProvider appInfo={{ app: { appName: 'uxdx' } }}>
      <div className="grid grid-rows-1 min-h-screen font-sans text-gray-900">
        {/* <div className='grid grid-rows-1 min-h-screen font-sans text-gray-900 h-screen'> */}
        <Header conference={conference} conferenceLinks={conferenceLinks} inPerson={inPerson} />

        <main className="pt-24">
          {filteredAnnouncements && <Announcement announcements={filteredAnnouncements} />}
          {children}
          {/* <div className='max-w-7xl mx-auto py-6 sm:px-6 lg:px-8'>{children}</div> */}
        </main>

        <Footer />
        {/* <CookieConsent
          location="bottom"
          buttonText="Accept"
          disableStyles="true"
          containerClasses="flex flex-wrap left-10 p-8 max-w-prose bg-slate-200 shadow-3xl rounded-lg border-2 border-gray-300 fixed z-10 mb-4"
          style={{ bottom: '10px !important' }}
          contentClasses=""
          buttonClasses="bg-blue-500 py-2 px-4 mt-4 text-white rounded-md"
          overlayStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }}
          cookieName="gatsby-gdpr-google-tagmanager"
        >
          <span className="font-medium">We use cookies in the delivery of our services.</span> To learn about
          the cookies we use and information about your preferences and opt-out choices, please{' '}
          <Link to="/cookie-policy" className="text-blue-800">
            click here
          </Link>
          . By using our platform you agree to our use of cookies.
        </CookieConsent> */}
      </div>
      {authService.loginModal?.isVisible && (
        <LoginModal
          openModal={authService.loginModal.isVisible}
          handleClose={() => authService.handleModalClose()}
        />
      )}
    </AppServiceProvider>
  )
}

// const query = graphql`
//   query {
//     confAnnouncements: allAirtableAnnouncements(filter: { data: { Future_Announcement: { eq: "FUTURE" } } }) {
//       nodes {
//         data {
//           Start_Date: Announcement_Start_Date
//           End_Date: Announcement_End_Date
//           Long_Text
//           Button_Text
//           Button_Link
//           Conference {
//             id
//           }
//         }
//       }
//     }
//   }
// `

BasicLayout.propTypes = {
  children: PropTypes.node.isRequired,
  conference: PropTypes.shape({
    id: PropTypes.string.isRequired,
    data: PropTypes.shape({
      Conference_Id: PropTypes.string.isRequired,
      Conference_Name: PropTypes.string.isRequired,
      Type: PropTypes.string.isRequired,
      Location: PropTypes.string.isRequired,
      Conference_Venue_Type: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
      Conference_Start_Date: PropTypes.string.isRequired,
      Conference_End_Date: PropTypes.string.isRequired,
      Days_Away: PropTypes.number.isRequired,
      Sessions: PropTypes.arrayOf(
        PropTypes.shape({
          data: PropTypes.shape({
            Session_Id: PropTypes.string,
            Session_Status: PropTypes.string,
            UTC_Start_Time: PropTypes.string,
            UTC_End_Time: PropTypes.string,
            Session_Groups: PropTypes.arrayOf(
              PropTypes.shape({
                data: PropTypes.shape({
                  Delivery: PropTypes.string.isRequired,
                }).isRequired,
              }).isRequired,
            ).isRequired,
          }).isRequired,
        }).isRequired,
      ).isRequired,
      Partners: PropTypes.arrayOf(PropTypes.object),
      Venue: PropTypes.arrayOf(
        PropTypes.shape({
          data: PropTypes.shape({
            Venue_Type: PropTypes.string.isRequired,
            Venue_City: PropTypes.string,
          }),
        }).isRequired,
      ).isRequired,
    }).isRequired,
  }).isRequired,
  conferenceLinks: PropTypes.shape({
    speakers: PropTypes.bool,
    partners: PropTypes.bool,
    tickets: PropTypes.bool,
  }).isRequired,
}

export default BasicLayout
